export const thumbnails =  {
    "Orthos2021": "https://js.arcgis.com/3.22/esri/images/basemap/satellite.jpg",
    "Streets2018": "https://js.arcgis.com/3.22/esri/images/basemap/topo.jpg",
    "Basemap": "https://js.arcgis.com/3.22/esri/images/basemap/satellite.jpg",
    "BasemapStreets": "https://js.arcgis.com/3.22/esri/images/basemap/topo.jpg",
    "Hybrid": "https://agis.wingis.org/maps/src/img/hybrid.jpg", 
    "No Map": "https://wingis.org" + window.RootUrl + "img/nomap.jpg"
}